import { render, staticRenderFns } from "./figura-detallado.vue?vue&type=template&id=81f364e2&"
import script from "./figura-detallado.vue?vue&type=script&lang=js&"
export * from "./figura-detallado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports